// client/src/pages/ServiceGuide.js
// 서비스 가이드 — v5 리디자인 (역할별 가이드 카드 2종 + FAQ CTA)
// PDF 파일 경로·버전 쿼리는 기존 그대로.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/public/pub.css';

const VERSION_QUERY = '?v=20260622'; // 정식 PDF 교체 시 날짜 갱신

const GUIDES = [
  {
    key: 'marketer',
    tone: 'mkt',
    icon: '📘',
    title: '광고주 가이드',
    summary: '포인트 충전 · 프로젝트 등록 · 인플루언서 선정 · 검수와 CPS 정산까지 전 과정을 담았어요.',
    file: '/guides/marketer-guide.pdf',
    downloadName: '셀프애드_광고주_가이드.pdf',
    btnClass: 'btn--blue',
  },
  {
    key: 'influencer',
    tone: 'inf',
    icon: '📗',
    title: '인플루언서 가이드',
    summary: '프로젝트 지원 · 계약과 결과물 제출 · 보상 적립과 환전까지, 활동에 필요한 모든 것을 담았어요.',
    file: '/guides/influencer-guide.pdf',
    downloadName: '셀프애드_인플루언서_가이드.pdf',
    btnClass: 'btn--mint',
  },
];

function ServiceGuide() {
  const nav = useNavigate();
  return (
    <div className="pub">
      <main className="wrap">
        <div className="pub-head">
          <h1>서비스 가이드</h1>
          <p>처음이신가요? 역할별 가이드북으로 전체 흐름을 한 번에 익혀보세요.</p>
        </div>

        <div className="guide">
          {GUIDES.map((g) => (
            <article key={g.key} className={`guide__card guide--${g.tone}`}>
              <i aria-hidden="true">{g.icon}</i>
              <b>{g.title}</b>
              <p>{g.summary}</p>
              <div className="row">
                <a
                  className={`btn ${g.btnClass}`}
                  href={`${g.file}${VERSION_QUERY}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  바로 보기
                </a>
                <a
                  className="btn btn--ghost"
                  href={`${g.file}${VERSION_QUERY}`}
                  download={g.downloadName}
                >
                  PDF 다운로드
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="faq-cta" style={{ marginTop: 26 }}>
          <b>읽다가 궁금한 게 생겼다면</b>
          <span className="t-sub">자주 묻는 질문에서 바로 답을 찾아보세요.</span>
          <button type="button" className="btn btn--ghost" onClick={() => nav('/faq')}>
            FAQ 보기
          </button>
        </div>
      </main>
    </div>
  );
}

export default ServiceGuide;
